module.exports = __webpack_public_path__ + "img/step16_a_stand_power_remove_stacker_supports.85c5d520.png";